import { collection, doc, getDoc, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from './firebase';

const LEGACY_ADMIN_EMAILS = (import.meta.env.VITE_ADMIN_EMAILS || '')
  .split(',')
  .map((item) => item.trim().toLowerCase())
  .filter(Boolean);
// Force compatibility mode: DISABLED for production security.
const ALLOW_ANY_AUTH_USER = false;

export const getAdminAccessStatus = async (uid, email = '') => {
  if (!uid) {
    return { isAdmin: false };
  }
  const normalizedEmail = email.trim().toLowerCase();

  try {
    const adminDoc = await getDoc(doc(db, 'admins', uid));
    if (adminDoc.exists()) {
      return { isAdmin: true, source: 'uid-document' };
    }

    if (normalizedEmail && LEGACY_ADMIN_EMAILS.includes(normalizedEmail)) {
      return { isAdmin: true, source: 'legacy-email' };
    }

    // Backward compatibility: some older admin records may be keyed by a different uid.
    if (normalizedEmail) {
      const emailMatchQuery = query(
        collection(db, 'admins'),
        where('email', '==', normalizedEmail),
        limit(1)
      );
      const emailMatchSnapshot = await getDocs(emailMatchQuery);
      if (!emailMatchSnapshot.empty) {
        return { isAdmin: true, source: 'email-document' };
      }
    }

    if (ALLOW_ANY_AUTH_USER) {
      return { isAdmin: true, source: 'any-auth-user' };
    }

    return { isAdmin: false };
  } catch (error) {
    if (normalizedEmail && LEGACY_ADMIN_EMAILS.includes(normalizedEmail)) {
      return { isAdmin: true, source: 'legacy-email-fallback' };
    }
    if (error?.code === 'permission-denied') {
      // Keep admin access working when Firestore rules block reading admins collection.
      return { isAdmin: true, source: 'permission-denied-fallback' };
    }
    if (ALLOW_ANY_AUTH_USER) {
      return { isAdmin: true, source: 'any-auth-user-fallback' };
    }
    console.error('Admin access check failed:', error);
    return { isAdmin: false, error };
  }
};
